(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dc-photo-order-guide"] && !Shopify.designMode) return;
  try {
    (() => {
  const root = document.getElementById('MainContent');
  if (!root) return;
  let scheduled = false;
  const update = () => {
    scheduled = false;
    const guide = root.querySelector('[data-dc-photo-upload-label]');
    if (!guide) return;
    const fields = Array.from(root.querySelectorAll('.uploadfly-input-section input.uploadfly[type="file"]'));
    fields.forEach((field, index) => {
      const group = field.closest('.uploadfly-input-section');
      const label = Array.from(group.querySelectorAll('label')).find(item => item.htmlFor === field.id);
      if (!label) return;
      const caption = guide.dataset.dcPhotoUploadLabel + (fields.length > 1 ? ' ' + (index + 1) : '');
      if (label.textContent !== caption) label.textContent = caption;
      group.classList.add('dc-photo-upload');
    });
  };
  const observer = new MutationObserver(() => {
    if (!scheduled) {
      scheduled = true;
      requestAnimationFrame(update);
    }
  });
  observer.observe(root, {childList:true,subtree:true});
  update();
  window.addEventListener('pagehide', () => observer.disconnect(), {once:true});
})();
  } catch(e) { console.error(e); }
})();

})();
